export interface Country {
    name: string
    code: string
    dialCode: string
    flag: string
    currency: string
}

export const countries: Country[] = [
    { name: 'Afghanistan', code: 'af', dialCode: '93', flag: '🇦🇫', currency: 'AFN' },
    { name: 'Albania', code: 'al', dialCode: '355', flag: '🇦🇱', currency: 'ALL' },
    { name: 'Algeria', code: 'dz', dialCode: '213', flag: '🇩🇿', currency: 'DZD' },
    { name: 'Angola', code: 'ao', dialCode: '244', flag: '🇦🇴', currency: 'AOA' },
    { name: 'Argentina', code: 'ar', dialCode: '54', flag: '🇦🇷', currency: 'ARS' },
    { name: 'Australia', code: 'au', dialCode: '61', flag: '🇦🇺', currency: 'AUD' },
    { name: 'Austria', code: 'at', dialCode: '43', flag: '🇦🇹', currency: 'EUR' },
    { name: 'Bahrain', code: 'bh', dialCode: '973', flag: '🇧🇭', currency: 'BHD' },
    { name: 'Bangladesh', code: 'bd', dialCode: '880', flag: '🇧🇩', currency: 'BDT' },
    { name: 'Belgium', code: 'be', dialCode: '32', flag: '🇧🇪', currency: 'EUR' },
    { name: 'Bolivia', code: 'bo', dialCode: '591', flag: '🇧🇴', currency: 'BOB' },
    { name: 'Botswana', code: 'bw', dialCode: '267', flag: '🇧🇼', currency: 'BWP' },
    { name: 'Brazil', code: 'br', dialCode: '55', flag: '🇧🇷', currency: 'BRL' },
    { name: 'Cameroon', code: 'cm', dialCode: '237', flag: '🇨🇲', currency: 'XAF' },
    { name: 'Canada', code: 'ca', dialCode: '1', flag: '🇨🇦', currency: 'CAD' },
    { name: 'Chile', code: 'cl', dialCode: '56', flag: '🇨🇱', currency: 'CLP' },
    { name: 'China', code: 'cn', dialCode: '86', flag: '🇨🇳', currency: 'CNY' },
    { name: 'Colombia', code: 'co', dialCode: '57', flag: '🇨🇴', currency: 'COP' },
    { name: 'Congo', code: 'cg', dialCode: '242', flag: '🇨🇬', currency: 'XAF' },
    { name: 'DR Congo', code: 'cd', dialCode: '243', flag: '🇨🇩', currency: 'CDF' },
    { name: 'Denmark', code: 'dk', dialCode: '45', flag: '🇩🇰', currency: 'DKK' },
    { name: 'Ecuador', code: 'ec', dialCode: '593', flag: '🇪🇨', currency: 'USD' },
    { name: 'Egypt', code: 'eg', dialCode: '20', flag: '🇪🇬', currency: 'EGP' },
    { name: 'Ethiopia', code: 'et', dialCode: '251', flag: '🇪🇹', currency: 'ETB' },
    { name: 'Finland', code: 'fi', dialCode: '358', flag: '🇫🇮', currency: 'EUR' },
    { name: 'France', code: 'fr', dialCode: '33', flag: '🇫🇷', currency: 'EUR' },
    { name: 'Germany', code: 'de', dialCode: '49', flag: '🇩🇪', currency: 'EUR' },
    { name: 'Ghana', code: 'gh', dialCode: '233', flag: '🇬🇭', currency: 'GHS' },
    { name: 'Greece', code: 'gr', dialCode: '30', flag: '🇬🇷', currency: 'EUR' },
    { name: 'India', code: 'in', dialCode: '91', flag: '🇮🇳', currency: 'INR' },
    { name: 'Indonesia', code: 'id', dialCode: '62', flag: '🇮🇩', currency: 'IDR' },
    { name: 'Iran', code: 'ir', dialCode: '98', flag: '🇮🇷', currency: 'IRR' },
    { name: 'Iraq', code: 'iq', dialCode: '964', flag: '🇮🇶', currency: 'IQD' },
    { name: 'Ireland', code: 'ie', dialCode: '353', flag: '🇮🇪', currency: 'EUR' },
    { name: 'Israel', code: 'il', dialCode: '972', flag: '🇮🇱', currency: 'ILS' },
    { name: 'Italy', code: 'it', dialCode: '39', flag: '🇮🇹', currency: 'EUR' },
    { name: 'Ivory Coast', code: 'ci', dialCode: '225', flag: '🇨🇮', currency: 'XOF' },
    { name: 'Japan', code: 'jp', dialCode: '81', flag: '🇯🇵', currency: 'JPY' },
    { name: 'Jordan', code: 'jo', dialCode: '962', flag: '🇯🇴', currency: 'JOD' },
    { name: 'Kenya', code: 'ke', dialCode: '254', flag: '🇰🇪', currency: 'KES' },
    { name: 'Kuwait', code: 'kw', dialCode: '965', flag: '🇰🇼', currency: 'KWD' },
    { name: 'Lebanon', code: 'lb', dialCode: '961', flag: '🇱🇧', currency: 'LBP' },
    { name: 'Lesotho', code: 'ls', dialCode: '266', flag: '🇱🇸', currency: 'LSL' },
    { name: 'Libya', code: 'ly', dialCode: '218', flag: '🇱🇾', currency: 'LYD' },
    { name: 'Madagascar', code: 'mg', dialCode: '261', flag: '🇲🇬', currency: 'MGA' },
    { name: 'Malawi', code: 'mw', dialCode: '265', flag: '🇲🇼', currency: 'MWK' },
    { name: 'Malaysia', code: 'my', dialCode: '60', flag: '🇲🇾', currency: 'MYR' },
    { name: 'Mali', code: 'ml', dialCode: '223', flag: '🇲🇱', currency: 'XOF' },
    { name: 'Mexico', code: 'mx', dialCode: '52', flag: '🇲🇽', currency: 'MXN' },
    { name: 'Morocco', code: 'ma', dialCode: '212', flag: '🇲🇦', currency: 'MAD' },
    { name: 'Mozambique', code: 'mz', dialCode: '258', flag: '🇲🇿', currency: 'MZN' },
    { name: 'Namibia', code: 'na', dialCode: '264', flag: '🇳🇦', currency: 'NAD' },
    { name: 'Netherlands', code: 'nl', dialCode: '31', flag: '🇳🇱', currency: 'EUR' },
    { name: 'New Zealand', code: 'nz', dialCode: '64', flag: '🇳🇿', currency: 'NZD' },
    { name: 'Nigeria', code: 'ng', dialCode: '234', flag: '🇳🇬', currency: 'NGN' },
    { name: 'Norway', code: 'no', dialCode: '47', flag: '🇳🇴', currency: 'NOK' },
    { name: 'Oman', code: 'om', dialCode: '968', flag: '🇴🇲', currency: 'OMR' },
    { name: 'Pakistan', code: 'pk', dialCode: '92', flag: '🇵🇰', currency: 'PKR' },
    { name: 'Peru', code: 'pe', dialCode: '51', flag: '🇵🇪', currency: 'PEN' },
    { name: 'Philippines', code: 'ph', dialCode: '63', flag: '🇵🇭', currency: 'PHP' },
    { name: 'Poland', code: 'pl', dialCode: '48', flag: '🇵🇱', currency: 'PLN' },
    { name: 'Portugal', code: 'pt', dialCode: '351', flag: '🇵🇹', currency: 'EUR' },
    { name: 'Qatar', code: 'qa', dialCode: '974', flag: '🇶🇦', currency: 'QAR' },
    { name: 'Romania', code: 'ro', dialCode: '40', flag: '🇷🇴', currency: 'RON' },
    { name: 'Russia', code: 'ru', dialCode: '7', flag: '🇷🇺', currency: 'RUB' },
    { name: 'Rwanda', code: 'rw', dialCode: '250', flag: '🇷🇼', currency: 'RWF' },
    { name: 'Saudi Arabia', code: 'sa', dialCode: '966', flag: '🇸🇦', currency: 'SAR' },
    { name: 'Senegal', code: 'sn', dialCode: '221', flag: '🇸🇳', currency: 'XOF' },
    { name: 'Sierra Leone', code: 'sl', dialCode: '232', flag: '🇸🇱', currency: 'SLL' },
    { name: 'Singapore', code: 'sg', dialCode: '65', flag: '🇸🇬', currency: 'SGD' },
    { name: 'Somalia', code: 'so', dialCode: '252', flag: '🇸🇴', currency: 'SOS' },
    { name: 'South Africa', code: 'za', dialCode: '27', flag: '🇿🇦', currency: 'ZAR' },
    { name: 'South Korea', code: 'kr', dialCode: '82', flag: '🇰🇷', currency: 'KRW' },
    { name: 'Spain', code: 'es', dialCode: '34', flag: '🇪🇸', currency: 'EUR' },
    { name: 'Sri Lanka', code: 'lk', dialCode: '94', flag: '🇱🇰', currency: 'LKR' },
    { name: 'Sudan', code: 'sd', dialCode: '249', flag: '🇸🇩', currency: 'SDG' },
    { name: 'Sweden', code: 'se', dialCode: '46', flag: '🇸🇪', currency: 'SEK' },
    { name: 'Switzerland', code: 'ch', dialCode: '41', flag: '🇨🇭', currency: 'CHF' },
    { name: 'Tanzania', code: 'tz', dialCode: '255', flag: '🇹🇿', currency: 'TZS' },
    { name: 'Thailand', code: 'th', dialCode: '66', flag: '🇹🇭', currency: 'THB' },
    { name: 'Tunisia', code: 'tn', dialCode: '216', flag: '🇹🇳', currency: 'TND' },
    { name: 'Turkey', code: 'tr', dialCode: '90', flag: '🇹🇷', currency: 'TRY' },
    { name: 'Uganda', code: 'ug', dialCode: '256', flag: '🇺🇬', currency: 'UGX' },
    { name: 'Ukraine', code: 'ua', dialCode: '380', flag: '🇺🇦', currency: 'UAH' },
    { name: 'United Arab Emirates', code: 'ae', dialCode: '971', flag: '🇦🇪', currency: 'AED' },
    { name: 'United Kingdom', code: 'gb', dialCode: '44', flag: '🇬🇧', currency: 'GBP' },
    { name: 'United States', code: 'us', dialCode: '1', flag: '🇺🇸', currency: 'USD' },
    { name: 'Venezuela', code: 've', dialCode: '58', flag: '🇻🇪', currency: 'VES' },
    { name: 'Vietnam', code: 'vn', dialCode: '84', flag: '🇻🇳', currency: 'VND' },
    { name: 'Yemen', code: 'ye', dialCode: '967', flag: '🇾🇪', currency: 'YER' },
    { name: 'Zambia', code: 'zm', dialCode: '260', flag: '🇿🇲', currency: 'ZMW' },
    { name: 'Zimbabwe', code: 'zw', dialCode: '263', flag: '🇿🇼', currency: 'ZWL' },
]

export const getCurrency = (countryName: string): string => {
    return countries.find(c => c.name === countryName)?.currency ?? 'KES'
}

export const getCurrencyByPhone = (phone: string): string => {
    const digits = phone.replace(/^\+/, '')
    for (const len of [3, 2, 1]) {
        const country = countries.find(c => c.dialCode === digits.substring(0, len))
        if (country) return country.currency
    }
    return 'KES'
}
